import { FC } from "react";
import { Text, Tr, Td, Th, Icon } from "@smile2impress/components/relaunch";
import {
    Box,
    CheckmarkFilledBoldIcon,
    CrossFilledBoldIcon,
} from "@smile2impress/components";

import { RowProps } from "./Row.types";

export const Row: FC<RowProps> = ({ title, columns, columnMaxW }) => {
    return (
        <Tr>
            <Th {...(columnMaxW && { w: columnMaxW })}>
                <Text
                    textAlign="left"
                    textStyle={["captionSmall", "captionSmall", "caption"]}
                    fontWeight={["normal", "normal", "bold"]}
                >
                    {title}
                </Text>
            </Th>
            {columns.map((column, index) => (
                <Td key={index} {...(columnMaxW && { w: columnMaxW })}>
                    {column ? (
                        <Box
                            display="inline-block"
                            borderRadius="50%"
                            bgColor="base.blue"
                            h="24px"
                            w="24px"
                            textAlign="center"
                        >
                            <Icon
                                as={CheckmarkFilledBoldIcon}
                                color="base.white"
                                h="10px"
                                w="12px"
                            />
                        </Box>
                    ) : (
                        <Icon
                            as={CrossFilledBoldIcon}
                            color="base.gunmetal"
                            h="14px"
                            w="14px"
                        />
                    )}
                </Td>
            ))}
        </Tr>
    );
};
